import React from 'react';
import { Editor } from '../components/Editor';

export const EditorPage = () => {
  return <Editor />;
};
